/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 29/10/2021
 */

import {JournalEntryType} from "@shared/Journal/JournalEntryType";
import {TaskJournalEntry} from "./journalEntry-imports";
import {FilterableProperty} from "@shared/Filterable/PropertyDecorators";
import {timestampFormatted} from "@/utils/helpers";

export default class LegalDocJournalEntry extends TaskJournalEntry {

	@FilterableProperty()
	legalDocTitle: string = null

	legalDocId: string = null
	legalDocSignedId: string = null
	currentSigner: string = null

	isSentForSignature: boolean = false
	sentDateTs: number = null


	constructor() {
		super();
		this.type = JournalEntryType.LEGAL_DOC
	}

	setLegalDoc(legalDoc){
		this.legalDocTitle = legalDoc.title
		this.legalDocId = legalDoc.id
	}


	dueDateFormatted(){
		if(this.dueDateTs){
			return "Due on " + timestampFormatted(this.dueDateTs)
		}
		return ""//"No Due Date"
	}

	summaryFormatted(){
		return this.legalDocTitle ? "" + this.legalDocTitle : "Legal Document"
	}

	assignFromFileRef(file){
		super.assignFromFileRef(file)
		this.legalDocTitle = file.name
		this.legalDocId = file.id
	}


}
